/**
 * @generated SignedSource<<9f259a72e2569815e92c200ce43b8093>>
 * @relayHash 11aef5b73cd2358066b347e49ba1cd1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 457c99bbecca693bb8c7cadcbb267f0255fc64513ff95a8804c1eedd53b66f29

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlaskitAtlassianNavigationNav4UIQuery$variables = {
  cloudId: string;
  includeExtraMenuItems: boolean;
};
export type AtlaskitAtlassianNavigationNav4UIQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData" | "Nav4Profile">;
};
export type AtlaskitAtlassianNavigationNav4UIQuery = {
  response: AtlaskitAtlassianNavigationNav4UIQuery$data;
  variables: AtlaskitAtlassianNavigationNav4UIQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeExtraMenuItems"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraNavigationUIStateUserProperty",
              "kind": "LinkedField",
              "name": "navigationUIState",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v2/*: any*/),
                  "action": "THROW",
                  "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Profile"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4NotificationsData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "condition": "includeExtraMenuItems",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "457c99bbecca693bb8c7cadcbb267f0255fc64513ff95a8804c1eedd53b66f29",
    "metadata": {},
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4a64113996a8847c2a4d1237c6d62f17";

export default node;
